<template>
  <Card
    v-if="applicant.competitionResults.histories.length > 0"
    class="pa-4"
    white
  >
    <FlexColumn>
      <Label size="h6" bold text="コンペティション参加実績" />
      <FlexColumn v-for="(history, index) in applicant.competitionResults.histories" :key="`applicant-competitions-card-history-${index}`">
        <FlexRow justify="space-between" align="center">
          <Label bold :text="history.name" />
          <v-img v-if="history.medal === 1" src="@/assets/medal_gold.png" max-width="28px"/>
          <v-img v-if="history.medal === 2" src="@/assets/medal_silver.png" max-width="28px"/>
          <v-img v-if="history.medal === 3" src="@/assets/medal_bronze.png" max-width="28px"/>
        </FlexRow>
        <FlexRow>
          <Label text="期間："/>
          <Label :text="dateToText(history.startAt)" />
          <Label text="-"/>
          <Label :text="dateToText(history.closingAt)" />
        </FlexRow>
        <FlexRow>
          <Label text="順位：" />
          <Label :text="rankText(history.rank)" />
        </FlexRow>
        <Divider v-if="applicant.competitionResults.histories.length - 1 !== index" />
      </FlexColumn>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import FlexRow from "@/components/atoms/FlexRow";
import ComponentMixin from "@/components/ComponentMixin";
import Divider from "@/components/atoms/Divider";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantCompetitionsCard",
  components: {Divider, FlexRow, Label, FlexColumn, Card},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    rankText() {
      return (value) => {
        if (value == null) {
          return "-"
        }
        const rank = Math.ceil(value * 100)
        if (rank <= 10) {
          return `Top${rank}%`
        }
        if (rank > 50) {
          return "Over50%"
        }
        return `Top${Math.ceil(rank / 10) * 10}%`
      }
    }
  }
}
</script>

<style scoped>

</style>
